import { Box, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { SubpageLayout } from '@/components/architecture/Layout/SubpageLayout';
import { Button } from '@/components/form/baseInputs/Button';
import { Card } from '@/components/layout/Card/Card';
import { Callout } from '@/components/notifications/Callout/Callout';
import { diagnostics } from '@/utils/diagnostics';

import { useCreateAuditLogsLinkMutation } from './graphql/AuditLogsLink.generated';

export function AdminAuditLogPage() {
  const [error, setError] = useState<string | null>(null);
  const [createAuditLogsLink, { loading }] = useCreateAuditLogsLinkMutation();

  const handleOpenAuditLog = async () => {
    try {
      setError(null);
      const result = await createAuditLogsLink();
      if (result.data?.auditLogsLink) {
        const url = String(result.data.auditLogsLink);
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        throw new Error('Empty response from createAuditLogsLink');
      }
    } catch (err) {
      const errorMessage = 'Failed to fetch audit log URL';
      setError(errorMessage);
      diagnostics.error(errorMessage, err as Error);
    }
  };

  return (
    <SubpageLayout>
      <Stack spacing={2}>
        <Typography variant="title-xl" mb={2}>
          Audit Log
        </Typography>
        <Card variant="outlined" sx={{ p: 2 }}>
          {error && <Callout severity="error">{error}</Callout>}
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Button
              variant="primary"
              size="sm"
              loading={loading}
              onClick={handleOpenAuditLog}
            >
              Open audit log
            </Button>
          </Box>
        </Card>
      </Stack>
    </SubpageLayout>
  );
}
